import { rtkApi } from 'src/Common/RTK/api/rtkApi';
import { store as RtkStore } from 'src/Common/RTK/store/index.ts';

export const invalidateViewsTags = () => {
  RtkStore.dispatch(rtkApi.util.invalidateTags(['GetViews']));
};

export const invalidateFolderTags = () => {
  RtkStore.dispatch(rtkApi.util.invalidateTags(['ViewFolders']));
};

export const invalidateViewsAndFolderTags = () => {
  RtkStore.dispatch(rtkApi.util.invalidateTags(['GetViews', 'ViewFolders']));
};